export default class Toggleable {
  constructor(button, target, scope = null, scroll = false) {
    this.$button = $(button);
    this.$target = $(target);
    this.$scope = scope ? $(scope) : null;
    this.scroll = scroll;

    if (this.$button.hasClass('toggleable--open')) {
      this.$target.addClass('toggleable__target--open');
    }

    this.$button.click(this.toggle.bind(this));
  }

  toggle(e) {
    if (this.$button.hasClass('toggleable--open')) {
      if (this.$button.attr('href') == '#') {
        e.preventDefault();
      }

      this.close();
      return;
    }

    e.preventDefault();
    this.open();
  }

  open() {
    if (this.$scope) {
      this.$scope
        .removeClass('toggleable--open')
        .removeClass('toggleable__target--open');
    }

    this.$button.addClass('toggleable--open');
    this.$target.addClass('toggleable__target--open');

    if (this.scroll) {
      this.scrollTo(this.$target);
    }
  }

  close() {
    this.$button.removeClass('toggleable--open');
    this.$target.removeClass('toggleable__target--open');
  }

  scrollTo($element) {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $element.offset().top - 100,
      },
      500
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Toggleable.js